import request from '@/utils/request'
import upRequest from '@/utils/upload-request'
// import store from '@/store'

/* upload-request使用的是VUE_APP_NETWORK_API是权限系统接口不加网关（/user-service）* */
// 注意request接口 Authorization对应的值不是token 而是systemCode!
// 上传图片
export function uploadImg(fileObj) {
  const formdata = new FormData()
  formdata.append('file', fileObj.file, fileObj.file.name)
  return upRequest({
    url: `/task-management/api/common/upload`,
    method: 'post',
    data: formdata
  })
}
// tinymce编译器上传图片
export function tinymceUploadImg(blob, name) {
  const formdata = new FormData()
  formdata.append('file', blob, name)
  return process.env.NODE_ENV === 'production' ? upRequest({
    url: `/task-management/api/common/upload`,
    method: 'post',
    data: formdata
  }): request({
    url: `common/upload`,
    method: 'post',
    data: formdata
  })
}

// 删除上传
export function deleteUpload(reqParams) {
  return request({
    url: `common/delete-upload`,
    method: 'post',
    data: reqParams
  })
}

// 下载文件
export function downloadUpload(file_path) {
  return request({
    headers: { 'Content-Type': 'multipart/form-data' },
    url: `common/download-upload`,
    method: 'post',
    data: { file_path: file_path }
  })
}
